<script setup lang="ts">
withDefaults(defineProps<{
  eyebrow?: string
  title: string
  description?: string
  meta?: string
  compact?: boolean
}>(), {
  eyebrow: '',
  description: '',
  meta: '',
  compact: false
})
</script>

<template>
  <header class="rr-page-header" :class="{ 'is-compact': compact }">
    <div class="rr-page-header__copy">
      <p v-if="eyebrow" class="rr-page-header__eyebrow">{{ eyebrow }}</p>
      <div class="rr-page-header__title-row">
        <h2>{{ title }}</h2>
        <span v-if="meta" class="rr-page-header__meta">{{ meta }}</span>
        <slot name="meta" />
      </div>
      <p v-if="description" class="rr-page-header__description">{{ description }}</p>
      <slot name="description" />
    </div>
    <div v-if="$slots.actions" class="rr-page-header__actions">
      <slot name="actions" />
    </div>
  </header>
</template>

<style scoped>
.rr-page-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: var(--rr-space-5);
  min-width: 0;
  padding: 3px 1px 2px;
}

.rr-page-header__copy {
  display: grid;
  min-width: 0;
  gap: 5px;
}

.rr-page-header__eyebrow,
.rr-page-header__description,
.rr-page-header h2 {
  margin: 0;
}

.rr-page-header__eyebrow {
  color: var(--rr-color-primary);
  font-size: 11px;
  font-weight: 760;
  line-height: 1.3;
  text-transform: uppercase;
}

.rr-page-header__title-row {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.rr-page-header h2 {
  overflow: hidden;
  color: var(--rr-color-text-strong);
  font-size: 20px;
  font-weight: 760;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rr-page-header__meta {
  flex: 0 0 auto;
  border-left: 1px solid var(--rr-color-border-strong);
  color: var(--rr-color-text-muted);
  font-size: 12px;
  font-variant-numeric: tabular-nums;
  padding-left: 10px;
}

.rr-page-header__description {
  max-width: 76ch;
  color: var(--rr-color-text-muted);
  font-size: 13px;
  line-height: 1.55;
}

.rr-page-header__actions {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;
}

.rr-page-header.is-compact h2 {
  font-size: 17px;
}

@media (max-width: 720px) {
  .rr-page-header {
    align-items: stretch;
    flex-direction: column;
  }

  .rr-page-header__actions {
    justify-content: flex-start;
  }

  .rr-page-header h2 {
    white-space: normal;
  }
}
</style>
